module.exports = __webpack_public_path__ + "img/hand-thumbs-up.847001de.svg";